import { FormEvent, useState } from "react";

import instance from "../../../api/instance";
import { useSyncGlobalPageLoader } from "../../../contexts/global-page-loader-context";

type ReportType = "general_report" | "credit_refrance_report";

interface ReportRow {
  sr_no: number;
  name: string;
  amount: number | string;
}

const GeneralReportPage = () => {
  const [reportType, setReportType] = useState<ReportType>("general_report");
  const [rows, setRows] = useState<ReportRow[]>([]);
  const [loading, setLoading] = useState(false);

  useSyncGlobalPageLoader(loading);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await instance.get("general-report", { params: { type: reportType } });
      const list: ReportRow[] = Array.isArray(data?.data) ? data.data : [];
      setRows(list);
    } catch {
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="listing-grid">
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-flex align-items-center justify-content-between">
            <h4 className="mb-0 font-size-18">General Report</h4>
            <div className="page-title-right" />
          </div>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-12">
          <form method="post" onSubmit={handleSubmit}>
            <div className="row row5">
              <div className="col-md-4 col-xl-2">
                <div className="form-group">
                  {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                  <label>Select Type</label>
                  <select
                    name="type"
                    className="form-control"
                    value={reportType}
                    onChange={(e) => setReportType(e.target.value as ReportType)}
                  >
                    <option value="general_report">General Report</option>
                    <option value="credit_refrance_report">Credit Refrance Report</option>
                  </select>
                </div>
              </div>
              <div className="col-md-4 col-xl-3 mt-4">
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? "Loading..." : "Load"}
                </button>
              </div>
            </div>
          </form>

          <div className="table-responsive mb-0 report-table">
            <table
              role="table"
              aria-busy="false"
              aria-colcount={3}
              className="table b-table table-striped table-bordered"
            >
              <thead>
                <tr role="row">
                  <th role="columnheader" scope="col" aria-colindex={1}>
                    <div>Sr.No</div>
                  </th>
                  <th role="columnheader" scope="col" aria-colindex={2}>
                    <div>Name</div>
                  </th>
                  <th role="columnheader" scope="col" aria-colindex={3}>
                    <div>Amount</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 ? (
                  <tr className="b-table-empty-row">
                    <td colSpan={3}>
                      <div role="alert" aria-live="polite">
                        <p className="text-center mb-0">
                          {loading ? "Loading..." : "No data available in table"}
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  rows.map((row, idx) => (
                    <tr key={idx} role="row">
                      <td aria-colindex={1}>{row.sr_no ?? idx + 1}</td>
                      <td aria-colindex={2}>{row.name}</td>
                      <td aria-colindex={3}>{row.amount}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralReportPage;
